// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__qJ0VN","container":"styles_container__iLel+"};